// extracted by mini-css-extract-plugin
module.exports = {"titleCase":"_ede902b"};